/* istanbul ignore file */
export default {
  close: 'close',
  columns: 'Columns',
  downloadCsv: 'Download as CSV',
  downloadExcel: 'Download as Excel',
  export: 'Export',
  filters: 'Filters',
  lastSync: 'As of {0}',
  lastSyncLabel: 'Last Sync',
  print: 'Print',
  search: {
    button: 'Apply Search Query',
    clear: 'Clear',
    label: 'Search',
    placeholder: 'Search'
  }
};
